// import { canUseDOM } from 'exenv';

export function tagVideoLoading(resp = {}, store = {}) {
  return {
    type: 'TAG_VIDEO_LOADING',
    tagVideo: resp,
    store
  };
}

export function tagVideoLoaded(resp = {}, store = {}) {
  return {
    type: 'TAG_VIDEO_LOADED',
    tagVideo: resp,
    store
  };
}

export function tagVideoLoadError(error, store = {}) {
  return {
    type: 'TAG_VIDEO_ERROR',
    tagVideo: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
